const fillServerErrors = require('../../olycommon/servererrorfiller');

class LoginFormController {
    constructor($q, $state, $timeout, $document, loginService, featureService, shopperService, analytics) {
        this.$q = $q;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$document = $document;
        this.loginService = loginService;
        this.shopperService = shopperService;
        this.analytics = analytics;

        this.rememberMeEnabled = featureService.isEnabled(featureService.features.rememberMe);
        this.loading = false;
    }

    $onInit() {

        this.shopper = this.shopperService.refreshShopperDetails();

        this.analyticsEvents = {
            EmailInput: this.analytics.events.LOGIN.FORM_FILL_EMAIL_ADDRESS,
            PasswordInput: this.analytics.events.LOGIN.FORM_FILL_PASSWORD,
            RememberMeInput: this.analytics.events.LOGIN.FORM_FILL_REMEMBER_ME,
        };
        this.analytics.pushEvent(this.analytics.events.LOGIN.START);

        this.isReauthorizing = !!(this.shopper.Id && this.authenticationMethod === 'RememberMe');

        if (this.isReauthorizing) {
            this.Email = this.shopper.Email;
            this.loginService.loginPromptMessage = this.loginService.LoginToContinueWhenRememberedMessage;
        }

        this.loadKasada();
    }

    loadKasada() {
        if (this.loginService.enableKasada && !this.loginService.kasadaLoaded) {
            const script = this.$document[0].createElement('script');
            script.type = 'application/javascript';
            script.src = this.loginService.kasadaScriptSource;

            const successEvent = () => {
                this.loadPostKasadaScript();
            };

            script.onload = successEvent;
            script.onreadystatechange = successEvent;

            this.$document[0].body.appendChild(script);
        }
    }

    loadPostKasadaScript() {
        const postScript = this.$document[0].createElement('script');
        const domain = window.location.hostname;

        postScript.type = 'application/javascript';
        postScript.innerHTML = `KPSDK.configure([{method: 'POST', domain: '${domain}', path: '/apis/ui/Login/SecureLoginWithCredential'}]);`;

        const postSuccessEvent = () => {
            this.loginService.kasadaLoaded = true;
        };

        postScript.onload = postSuccessEvent;
        postScript.onreadystatechange = postSuccessEvent;

        this.$document[0].body.appendChild(postScript);
    }

    setServerErrorValidity(isValid) {
        if (this.loginForm.Email) {
            this.loginForm.Email.$setValidity('loginError', isValid);
        }
        this.loginForm.Password.$setValidity('loginError', isValid);
    }

    login(email, password, rememberMe) {
        fillServerErrors.clearForm(this.loginForm, this);
        this.setServerErrorValidity(true);

        if (!this.loginForm.$valid) {
            // don't submit to server if client side is not valid
            return this.$q.reject();
        }

        this.loading = true;

        return this.loginService.login(email, password, rememberMe)
            .then((response) => {
                if (response.LoginResult === 'Success') { // this should check the response when it is implemented.
                    this.AuthenticationErrorMessage = null;
                    this.analytics.pushEvent(this.analytics.events.LOGIN.COMPLETED_MANUAL);

                    if (this.loginService.loginContext === 'checkout') {
                        this.$state.go('hyf');
                    }
                } else if (response.LoginResult === 'PartialSuccess') {
                    this.AuthenticationErrorMessage = null;
                    this.analytics.pushEvent(this.analytics.events.LOGIN.COMPLETED_MANUAL);
                } else if (response.LoginResult === 'RedirectPasswordRemainder') {
                    this.analytics.pushEvent(this.analytics.events.LOGIN.FAILURE);
                    this.AuthenticationErrorMessage = null;
                    this.$state.go('shop.authentication.forgotpassword');
                } else if (response.LoginResult === 'ResetPassword') {
                    this.analytics.pushEvent(this.analytics.events.LOGIN.FAILURE);
                    this.AuthenticationErrorMessage = null;
                    this.$state.go('shop.authentication.resetpassword', { passwordResetToken: response.PasswordResetToken });
                } else {
                    this.analytics.pushEvent(this.analytics.events.LOGIN.FAILURE);
                    this.AuthenticationErrorMessage = response.AuthenticationErrorMessage;
                    this.analytics.pushError(this.AuthenticationErrorMessage);
                    this.setServerErrorValidity(false);
                    this.loading = false;
                }

                return response;
            })
            .catch((response) => {
                fillServerErrors.fillForm(this.loginForm, response.data.ResponseStatus.Errors, this);
                this.setServerErrorValidity(false);
                this.loading = false;
            });
    }

    logout() {
        this.loginService.logout().then(() => {
            window.location.href = '/Shop/SecureLogin';
        });
    }
}

const loginFormComponentDefinition = {
    bindings: {
        authenticationMethod: '=?',
        isReauthorizing: '=',
    },
    controller: ['$q', '$state', '$timeout', '$document', 'LoginService', 'FeatureService', 'ShopperService', 'AnalyticsService', LoginFormController],
    template: require('./login-form.component.html').trim(),
};

module.exports = {
    LoginFormController,
    loginFormComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/auth/login/login-form.component.js